
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MissionClaimCreditDialog',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      isItem: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object,
        default: () => {}
      },
      btnText: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        quantity: 1,
        claimLoading: false
      }
    },
    computed: {
      ...mapState({
        player: state => state.player.player,
        activityWallet: state => state.player.activityWallet,
        isLogin: state => state.settings.isLogin
      }),
      modal: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      },
      totalCoins() {
        return this.quantity * this.item.amount_required
      },
      totalCreditAmount() {
        return this.quantity * this.item.credit_amount
      },
      isInsufficientCoin() {
        return this.totalCoins > this.activityWallet
      }
    },
    methods: {
      async onClaim() {
        const rewardId = this.item.id
        const body = {
          reward_type: this.isItem ? 2 : 1,
          tier_id: this.item.tier_id,
          quantity: this.quantity
        }
        this.claimLoading = true
        const response = await this.$store.dispatch('activities/exchange-reward/onClaimReward', {
          rewardId,
          body
        })
        this.claimLoading = false
        if (response.status) {
          this.$store.dispatch('player/totalBalance', {})
          this.$emit('success', true)
          this.modal = false
        } else {
          const { message, code } = response
          this.$emit('fail', {
            message,
            code
          })
          this.modal = false
        }
      },
      onIncrease() {
        this.quantity++
      },
      onDecrease() {
        if (this.quantity > 1) {
          this.quantity--
        }
      }
    }
  }
